<template>
  <a-modal
    title="查看质疑规则"
    :width="1000"
    :visible="visible"
    @cancel="viewHandleCancel"
    :footer="null">
    <div style="margin-bottom: 20px">
      项目：<a-select
        style="width: 90%"
        placeholder="请选择项目"
        v-model="queryParam.projectId"
        @change="loadDataMy"
        showSearch
        :filterOption="filterOption"
      >
        <a-select-option :value="item.id" v-for="item in projectList">{{item.name}}</a-select-option>
      </a-select>
    </div>
    <a-table :columns='columns'
             :dataSource='dataSource'
             :loading='loading'
             :pagination='ipagination'
             rowKey='id'
             size='small'
             @change='handleTableChange'>
        <span slot='action' slot-scope='text, record'>
          <a-button size='small' type='primary' @click='selectRecord(record)'>选择</a-button>
        </span>
    </a-table>
  </a-modal>
</template>

<script>
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { getAction,postAction } from '@/api/manage'
  export default {
    name: 'AddExist',
    mixins: [JeecgListMixin],
    props:{
      type:{
        type:String,
        default:'1',
      }
    },
    data() {
      return {
        url: {
          list: '/project/projectSysQuestion/list',
        },
        disableMixinCreated: true,
        visible:false,
        projectList:[]
      }
    },
    computed: {
      columns() {
        return [
          {
            title: '#',
            align: 'center',
            width: 80,
            customRender: (text, record, index) => index + 1
          },
          {
            title: '质疑表单',
            dataIndex: 'formName',
            width: 150,
            ellipsis: true
          },
          {
            title: '质疑元素',
            dataIndex: 'formItemName',
            width: 260,
            ellipsis: true
          },
          {
            title: '周期',
            dataIndex: 'periodType',
            width: 150,
            ellipsis: true,
            customRender:(text,record)=>{
              if(text ==='1'){
                return '所有周期'
              }else{
                return record.periodItemName
              }
            }
          },
          {
            title: '质疑说明',
            dataIndex: 'description',
            ellipsis: true
          },          
          {
            title: '操作',
            scopedSlots: { customRender: 'action' },            
          }
        ]
      }
    },
    created() {
      getAction('/management/project/listAll').then(res=>{
        if(res.success){
          this.projectList = res.result
        }
      })
    },
    methods:{
      filterOption(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      open(){
        this.visible = true
        this.queryParam = {}
        this.dataSource = []
      },
      selectRecord(record){
        this.$emit('handleSelect',record)
      },
      loadDataMy(){
        this.queryParam.type= this.type
        this.loadData()
      },
      viewHandleCancel(){
        this.visible = false
      }
    }
  }
</script>

<style scoped>

</style>